import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { usePrev } from '@services/hooks.service';
import Controls from './controls/Controls/Controls';
import { mapFactory, addSourcesAndLayersFromConfigToMap } from './maplibre-map.factory';
import { resizeMap } from './maplibre-map.utils';
import { setMapGlobal } from './maplibre-map.slice';
import { prefetchOfflineMapTiles } from './maplibre-map.prefetch';

import 'maplibre-gl/dist/maplibre-gl.css';
import './maplibre-map.styl';

function MaplibreMap(props) {
  const [map, setMap] = useState(null)
  const { mapResizeId, onMapInitialized } = props
  const mapRef = useRef(null);
  const prevMapResizeId = usePrev(mapResizeId)
  const prevMap = usePrev(map)
  const dispatch = useDispatch();

  const initialBoundsRef = useRef(props.initialBounds);

  useEffect(() => {
    const maplibreMap = mapFactory(mapRef.current, initialBoundsRef.current);
    setMap(maplibreMap);

    return () => {
      maplibreMap.remove();
    };
  }, []);

  useEffect(() => {
    if (map && (map !== prevMap)) {
      map.on('load', () => {
        addSourcesAndLayersFromConfigToMap(map)
        onMapInitialized(map);
        prefetchOfflineMapTiles();
      });
      dispatch(setMapGlobal(map));
    }
  }, [dispatch, map, onMapInitialized, prevMap]);

  useEffect(() => {
    if ((mapResizeId !== prevMapResizeId) && map) {
      resizeMap(map);
    }
  }, [map, mapResizeId, prevMapResizeId]);

  return (
    <div ref={mapRef} className="maplibre-map">
      <Controls map={map} />
    </div>
  );
}

export default MaplibreMap;